// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-section[data-v-b9c7ace2]{padding:0!important;overflow:hidden}.oops-notification__banner[data-v-b9c7ace2]{display:flex;justify-content:center;align-items:center}@media(max-width:600px){.oops-notification__banner[data-v-b9c7ace2]{display:none!important}}@media(max-width:600px){.oops-notification__content[data-v-b9c7ace2]{flex-basis:100%!important;padding-left:30px!important;max-width:100%}}.min-h-300[data-v-b9c7ace2]{min-height:150px}", ""]);
// Exports
module.exports = exports;
